import { jsx as g } from "@emotion/react/jsx-runtime";
import { StyledIcon as C } from "./DropdownIndicator.styled.js";
import { useDropdownIndicator as S } from "../../hooks/useDropdownIndicator.js";
import { useMultiSelectContext as x } from "../../MultiSelectContext.js";
import { IconPrefix as M } from "../../../../../types/components/icon.js";
const R = () => {
  const {
    dataTrackId: t,
    icon: e,
    disabled: n,
    error: c,
    warning: s,
    success: a,
    showMenu: i,
    selectedValue: o,
    readOnly: d,
    setShowMenu: l,
    onChange: p
  } = x(), r = !!o && o?.length > 0, {
    iconCaretColor: u,
    displayIcon: m
  } = S({
    canReset: r,
    error: c,
    warning: s,
    success: a,
    showMenu: i
  }), f = (h) => {
    h.stopPropagation(), l((w) => !w);
  }, I = () => {
    p([]);
  };
  if (!d)
    return /* @__PURE__ */ g(C, { dataTrackId: `show-filters-${t}`, color: u, disabled: n, icon: e ?? [m, M.SOLID], onClick: r ? I : f });
};
export {
  R as DropdownIndicator
};
